import React, { Component, Fragment } from 'react';
import Done from '@material-ui/icons/Done';
import Clear from '@material-ui/icons/Clear';
import RuleToggle from './RuleToggle';
import { objectToArray } from '../services/AMLModifyRuleService';
import { InfoTooltip } from '../../../../shared/info-tooltip/InfoTooltip';
import './Rule.scss';
import { EditButton } from '../../../../shared/button/EditButton';

class Rule extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isEditing: false,
            ruleActive: this.props.active,
            ruleVariables: this.extractPrefixAndPostFix(
                objectToArray(this.props.rule.ruleVariables)
            ), // ruleVariables have the form of [..]... or ...[..]
            fakeRule: this.props.rule.id === '-1'
        };

        this.startEdit = this.startEdit.bind(this);
        this.stopEdit = this.stopEdit.bind(this);
        this.saveEdit = this.saveEdit.bind(this);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps !== this.props) {
            this.setState({
                isEditing: false,
                ruleActive: this.props.active,
                ruleVariables: this.extractPrefixAndPostFix(
                    objectToArray(this.props.rule.ruleVariables)
                )
            });
            // Note: This logic means that once the parent component changes the props, this component will reload twice.
            // Once when the props change and another time when we set the state above.
        } else {
            // console.log("Props did not change.");
        }
    }

    startEdit() {
        !this.props.fakeRule && // if the Rule is a fake one we do not allow editing
        !this.props.readOnly && // nor if the user may not change rules
            this.setState({ isEditing: true });
    }

    stopEdit() {
        this.setState({
            isEditing: false,
            ruleVariables: this.extractPrefixAndPostFix(
                objectToArray(this.props.rule.ruleVariables)
            )
        });
    }

    saveEdit() {
        if (this.props.readOnly) {
            return;
        }
        this.props.updateRule(
            this.props.rule.id,
            this.extractVariablesToSave()
        );
        this.setState({ isEditing: false });
    }

    extractVariablesToSave() {
        let variablesToSave = {};
        this.state.ruleVariables.forEach(function(ruleVariable) {
            variablesToSave[ruleVariable.name] = ruleVariable.value;
        });
        // console.log("Variable to save: ", variablesToSave);
        return variablesToSave;
    }

    extractPrefixAndPostFix(ruleVariables) {
        return ruleVariables.map(variable => {
            let variableName = variable.name;
            let variableValue = variable.value;

            let indexOfSquareBrace = variableValue.indexOf('[');
            let indexOfEndSquareBrace = variableValue.indexOf(']');

            if (indexOfSquareBrace === -1) {
                return { name: variableName, value: variableValue };
            } else if (indexOfSquareBrace === 0) {
                // first label, then the text box =>  [..]...
                return {
                    name: variableName,
                    value: variableValue.slice(indexOfEndSquareBrace + 1),
                    prefix: variableValue.slice(
                        indexOfSquareBrace + 1,
                        indexOfEndSquareBrace
                    )
                };
            } else {
                // first text box, then label =>  ...[..]
                return {
                    name: variableName,
                    value: variableValue.slice(0, indexOfSquareBrace),
                    postfix: variableValue.slice(
                        indexOfSquareBrace + 1,
                        indexOfEndSquareBrace
                    )
                };
            }
        });
    }

    /** ************************* **/
    /** Building Rule description **/
    /** ************************* **/
    /* Main function to build rule description. */
    buildRule() {
        let rule = this.props.rule.rule;
        let ruleVariables = this.props.rule.ruleVariables;

        return (
            <span className={'rule-text'}>
                {this.renderRule(rule, ruleVariables)}
            </span>
        );
    }

    /* Renders the rule part, taking care of replacing templates with actual (rule variable) values.
     * This is a recursive function which recursively interpolates one variable at a time in the rule description.*/
    renderRule(str, ruleVariables) {
        // Get string until the first [
        let indexOfSqrBrace = str.indexOf('[');
        let indexOfClosingSqrBrace = str.indexOf(']');

        if (indexOfSqrBrace !== -1) {
            return (
                <Fragment>
                    {str.slice(0, indexOfSqrBrace)}
                    {this.handleTemplating(
                        str.slice(indexOfSqrBrace, indexOfClosingSqrBrace),
                        ruleVariables
                    )}
                    {this.renderRule(
                        str.slice(indexOfClosingSqrBrace + 1),
                        ruleVariables
                    )}
                </Fragment>
            );
        } else {
            return <Fragment>{str}</Fragment>;
        }
    }

    /* Handles templating. */
    handleTemplating(str, ruleVariables) {
        // console.log("Handling Templating for variables: ", ruleVariables);
        let startIndexOfVariable = str.indexOf('${') + 2;
        let endIndexOfVariable = str.indexOf('}');

        return (
            <span className={'darker-gray'}>
                {str.slice(1, startIndexOfVariable - 2)}{' '}
                {/*todo fix this .. the minus 2*/}
                {this.handleCurlyBraces(
                    str.slice(startIndexOfVariable, endIndexOfVariable),
                    ruleVariables
                )}
                {str.slice(endIndexOfVariable + 1, str.length)}
            </span>
        );
    }

    /* Handles templating. */
    handleCurlyBraces(variableName, ruleVariables) {
        if (ruleVariables && ruleVariables[variableName]) {
            let variable = ruleVariables[variableName];

            let indexOfSqrBrace = variable.indexOf('[');
            let indexOfClosingSqrBrace = variable.indexOf(']');

            if (indexOfSqrBrace !== -1) {
                // todo what if there's more than one square brace?
                variable =
                    variable.slice(0, indexOfSqrBrace) +
                    variable.slice(indexOfClosingSqrBrace + 1);
            }

            return (
                <span className={'rule-variable-input-field'}>
                    {(this.state.isEditing && (
                        <input
                            type="text"
                            defaultValue={variable}
                            className="rule-variable-input"
                            onChange={event =>
                                this.updateRuleVariable(
                                    variableName,
                                    event.target.value
                                )
                            }
                        />
                    )) || <span className={'blue'}>{variable}</span>}
                </span>
            );
        } else {
            console.error('No ruleVariables available to handle templating');
            // todo [mandy] throw an error when no variables are sent with the rule but the rule has templating in it?
        }
    }
    /** ***************************** **/
    /** End Building Rule description **/
    /** ***************************** **/

    /** *********************** **/
    /** Building Rule Variables **/
    /** *********************** **/

    updateRuleVariable(name, value) {
        // Find the variable from the state and push the new state to the parent.
        // Note: This might be reloading the component even if the state was not changed due to the variable not found.
        this.setState({
            ruleVariables: this.state.ruleVariables.map(variable => {
                if (variable.name === name) {
                    return {
                        name: name,
                        value: value,
                        prefix: variable.prefix,
                        postfix: variable.postfix
                    };
                } else {
                    return variable;
                }
            })
        });
    }
    /** *************************** **/
    /** End Building Rule Variables **/
    /** *************************** **/

    render() {
        return (
            <div className="rule">
                <span className="rule-info">{this.buildRule()}</span>
                {this.props.tooltipMessage && (
                    <InfoTooltip message={this.props.tooltipMessage} />
                )}

                <span className="action">
                    {this.props.readOnly ? null : this.state.isEditing ? (
                        <span>
                            <Done
                                className={'save-edit'}
                                onClick={this.saveEdit}
                            />
                            <Clear
                                className={'stop-edit'}
                                onClick={this.stopEdit}
                            />
                        </span>
                    ) : (
                        <span>
                            <RuleToggle
                                toggleOn={this.props.active}
                                ruleId={this.props.rule.id}
                                fakeRule={this.state.fakeRule}
                                enableRule={this.props.enableRule}
                                disableRule={this.props.disableRule}
                            />
                            {(this.props.active &&
                                this.state.ruleVariables &&
                                this.state.ruleVariables.length &&
                                !this.state.fakeRule && (
                                    <EditButton
                                        onClick={this.startEdit}
                                        hideText={true}
                                    />
                                )) ||
                                ''}
                        </span>
                    )}
                </span>
            </div>
        );
    }
}

export default Rule;
